<img [src]="getImgSource()" (error)="handleError()" [width]="size" [height]="size" />
